// src/components/InlineEditForm.js
import React, { useState } from 'react';

const InlineEditForm = ({ invoice, onSave, onCancel }) => {
  // حالت‌های اصلی فاکتور
  const [supplier, setSupplier] = useState(invoice.supplier);
  const [date, setDate] = useState(invoice.date);
  // حالت آیتم‌ها
  const [items, setItems] = useState(invoice.items.map(item => ({ ...item })));

  // تغییر در آیتم‌ها
  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    if (field === 'quantity' || field === 'unitPrice') {
      const numValue = parseFloat(value) || 0;
      newItems[index][field] = numValue;
      newItems[index].total = newItems[index].quantity * newItems[index].unitPrice;
    } else {
      newItems[index][field] = value;
    }
    setItems(newItems);
  };

  // اضافه کردن آیتم جدید
  const addItem = () => {
    setItems([...items, { id: Date.now(), product: '', quantity: 1, unitPrice: 0, total: 0 }]);
  };

  // حذف آیتم
  const removeItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
  };

  // ذخیره تغییرات
  const handleSave = () => {
    // اعتبارسنجی
    if (!supplier.trim()) {
      alert('لطفاً نام تامین‌کننده را وارد کنید.');
      return;
    }
    if (!date.trim()) {
      alert('لطفاً تاریخ را وارد کنید.');
      return;
    }
    if (items.length === 0) {
      alert('حداقل یک کالا باید وجود داشته باشد.');
      return;
    }
    for (let item of items) {
      if (!item.product.trim()) {
        alert('نام کالا نمی‌تواند خالی باشد.');
        return;
      }
      if (item.quantity <= 0) {
        alert('تعداد باید بزرگتر از صفر باشد.');
        return;
      }
      if (item.unitPrice <= 0) {
        alert('قیمت واحد باید بزرگتر از صفر باشد.');
        return;
      }
    }

    const totalAmount = items.reduce((sum, item) => sum + item.total, 0);
    onSave(invoice.id, {
      ...invoice,
      supplier,
      date,
      items,
      totalAmount
    });
    onCancel();
  };

  return (
    <div className="inline-edit-form">
      <div className="form-section">
        <h4>اطلاعات اصلی فاکتور</h4>
        <div className="main-fields">
          <div className="field-group">
            <label>🏢 تامین‌کننده:</label>
            <input
              type="text"
              value={supplier}
              onChange={(e) => setSupplier(e.target.value)}
              placeholder="نام تامین‌کننده"
            />
          </div>
          <div className="field-group">
            <label>📅 تاریخ:</label>
            <input
              type="text"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              placeholder="۱۴۰۲/۱۱/۱۰"
            />
          </div>
          <div className="field-group">
            <label>🏷️ شماره فاکتور:</label>
            <input type="text" value={invoice.invoiceNumber} disabled className="disabled-input" />
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>لیست کالاها</h4>
        <div className="items-editor">
          <table className="items-table">
            <thead>
              <tr>
                <th>نام کالا</th>
                <th>تعداد</th>
                <th>قیمت واحد</th>
                <th>جمع</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, idx) => (
                <tr key={idx}>
                  <td>
                    <input
                      type="text"
                      value={item.product}
                      onChange={(e) => handleItemChange(idx, 'product', e.target.value)}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={item.quantity}
                      onChange={(e) => handleItemChange(idx, 'quantity', e.target.value)}
                      min="1"
                    />
                  </td>
                  <td>
                    <input
                      type="number"value={item.unitPrice}
                      onChange={(e) => handleItemChange(idx, 'unitPrice', e.target.value)}
                      min="0"
                    />
                  </td>
                  <td className="total-cell">{item.total.toLocaleString('fa-IR')}</td>
                  <td>
                    <button className="remove-item" onClick={() => removeItem(idx)}>🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="add-item" onClick={addItem}>+ افزودن کالا</button>
        </div>
      </div>

      <div className="form-actions">
        <button className="save-btn" onClick={handleSave}>💾 ذخیره تغییرات</button>
        <button className="cancel-btn" onClick={onCancel}>❌ انصراف</button>
      </div>
    </div>
  );
};

export default InlineEditForm;